module.exports = __webpack_public_path__ + "img/logout-icon.53d21396.svg";